"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Search() {
  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['label']
    }, "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      "data-locator": "searchTerm.input",
      name: "searchTerm",
      placeholder: "\u041D\u043E\u043C\u0435\u0440 \u0432\u044B\u043F\u043B\u0430\u0442\u044B, \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435, email, \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u043C\u0430\u0441\u043A\u0430 \u043A\u0430\u0440\u0442\u044B, \u0442\u0435\u043A\u0441\u0442 \u043E\u0448\u0438\u0431\u043A\u0438"
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Search;
exports["default"] = _default;